import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'

export const useIsVirtualMarketer = () => {
  const { currentFolder } = useCurrentFolderStore()
  const workspace = useCurrentWorkspace()

  return workspace?.is_virtual_marketer || currentFolder?.workspace_is_virtual_marketer
}
